import Papa from 'papaparse'
import { generateIdempotencyKey } from '@/lib/gift-card-idempotency-key'

export const REASON_TEXT = {
  PHONE_REQUIRED: 'Phone number is required.',
  INVALID_PHONE: 'Not a valid mobile number.',
  INVALID_EMAIL: 'Invalid email address.',
  UNKNOWN: 'Could not import this customer.'
}

const toRecord = (values) =>
  values.reduce((record, value, index) => {
    record[`field${index + 1}`] = String(value).trim()
    return record
  }, {})

/**
 * Mirrors the importer's csvtojson `noheader` output so row numbers reported by the server index
 * the same array. `skipEmptyLines: 'greedy'` would drop whitespace-only and `,,` rows that the
 * server still counts, so it must stay `true`.
 */
export function parseCustomerImportCsv(input) {
  return new Promise((resolve, reject) => {
    Papa.parse(input, {
      header: false,
      skipEmptyLines: true,
      delimiter: ',',
      complete: ({ data }) => {
        const rows = data.map(toRecord)
        if (!rows.length) {
          reject(new Error('EMPTY_FILE'))
          return
        }
        resolve(rows)
      },
      error: (error) => reject(error)
    })
  })
}

export function generateImportId() {
  return generateIdempotencyKey()
}
